import { CircularProgress } from "@mui/material";
import MDBox from "components/MDBox";
import UiButton from "components/base/UiButton";

type SidebarFooterProps = {
  persisting: boolean;
  canSave: boolean;
  isDirty?: boolean;
  applyLoading: boolean;
  productsLoading: boolean;
  onSave: () => void;
  onApply: () => void;
  hideApply?: boolean;
  onCreateProposal?: () => void;
};

const getSaveLabel = (persisting: boolean, isDirty?: boolean) => {
  if (persisting) return "Saving...";
  if (isDirty) return "Save Assignments*";
  return "Save Assignments";
};

export default function SidebarFooter({
  persisting,
  canSave,
  isDirty,
  applyLoading,
  productsLoading,
  onSave,
  onApply,
  hideApply,
  onCreateProposal,
}: SidebarFooterProps) {
  return (
    <MDBox
      px="20px"
      py="16px"
      borderTop="1px solid #E5E7EB"
      display="flex"
      justifyContent="space-between"
      gap="12px"
    >
      <UiButton
        uiVariant={isDirty ? "primary-green" : "outlined"}
        onClick={onSave}
        disabled={persisting || !canSave}
      >
        {getSaveLabel(persisting, isDirty)}
      </UiButton>
      {!hideApply && (
        <UiButton
          uiVariant="primary-blue"
          onClick={onApply}
          disabled={persisting || applyLoading || productsLoading}
        >
          {applyLoading ? (
            <MDBox display="flex" alignItems="center" gap="8px">
              <CircularProgress size={16} />
              Updating...
            </MDBox>
          ) : (
            "Update Proposal"
          )}
        </UiButton>
      )}
      {onCreateProposal && (
        <UiButton uiVariant="primary-blue" onClick={onCreateProposal}>
          Create Proposal
        </UiButton>
      )}
    </MDBox>
  );
}
